/**
 * 判断当前比赛状态是否是 live
 * @param  {Number} status event status
 * @return {Boolean}       true 为 live, false 为其它（不一定是 prematch)
 */
export const isLiveMatch = (status) => status === 1 || status === 2

/**
 * 判断当前比赛状态是否是 prematch
 * @param  {Number} status   event status
 * @return {Boolean}              true 为 prematch, false 为其它（不一定是 live）
 */
export const isPrematch = (status) => status === 0 || status === 7

/**
 * Checks if the given market is active.
 *
 * A market is considered active if its status is either 0 or 1.
 *
 * @param {Object} market - The market object to check.
 * @param {number} market.status - The status of the market.
 * @returns {boolean} - Returns true if the market is active, otherwise false.
 */
export const isActiveMarket = (market) => {
  if (!market) return false
  const { status } = market
  return status === 0 || status === 1
}

/**
 * 获取比赛展示用的状态
 * @param  {String} event.sportId
 * @param  {String} event.statusDescription
 * @param  {Array} excludeStatus  待排除的 status description
 * @return {String}               比赛状态
 */
export const getMatchStatusDescription = ({ sportId, statusDescription }, excludeStatus = null) => {
  switch (sportId) {
    case 'sr:sport:1': // Soccer
      if (excludeStatus && excludeStatus.includes(statusDescription)) {
        return ''
      } else {
        return statusDescription
      }
    case 'lv:sport:1': {
      // VSoccer
      const vsoccerExcludeStatus = ['1st', '2nd', 'ended']
      if (vsoccerExcludeStatus.includes(statusDescription)) {
        return ''
      } else {
        return statusDescription
      }
    }
    default:
      // 当前比赛阶段
      return statusDescription || ''
  }
}
